export function getClientId() {
  return process.env.NEXT_PUBLIC_CLIENT_ID ?? '';
}
export function getWorkerHttpUrl() {
  return process.env.NEXT_PUBLIC_WORKER_HTTP_URL ?? '';
}
export function getHyperBackendUrl() {
  return process.env.NEXT_PUBLIC_API_ENDPOINT ?? 'https://dex-api.wildmeta.io/hyper';
}
